import { memo } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { IonItem } from '@ionic/react'
import queryString from 'query-string'
import { Channel } from 'stream-chat'
import { DefaultGenerics } from 'stream-chat'
import { ChannelPreviewUIComponentProps } from 'stream-chat-react'

import { Avatar } from '@components/atoms/Avatar'
import { UserName } from '@components/atoms/UserName'

import { UserInfo } from '@/services/user'
import { formatDate, isDateToday } from '@/utils/date'

import { Badge, DateFormat } from '@/enums'

interface ChannelListItemProps
  extends Pick<
    ChannelPreviewUIComponentProps,
    'lastMessage' | 'latestMessage'
  > {
  channel: Channel<DefaultGenerics>
  authUser: UserInfo
  history: RouteComponentProps['history']
}

const ChannelListItemComponent = ({
  channel,
  authUser,
  history,
  lastMessage,
  latestMessage,
}: ChannelListItemProps) => {
  const {
    location: { search = '' },
  } = history
  const { page = '' } = queryString.parse(search) as { page: string }
  const userId = Object.keys(channel?.state?.members)?.filter(
    (member) => member !== authUser.id
  )?.[0]

  const data = {
    avatar: channel?.state?.members?.[userId].user.image,
    lastMessageTimestamp: channel?.state.last_message_at
      ? formatDate(
          channel?.state.last_message_at,
          isDateToday(channel?.state.last_message_at)
            ? DateFormat.hhmm
            : DateFormat.ddMMyyyy
        )
      : null,
    username: channel?.state?.members?.[userId].user.name,
    isModerator: channel?.state?.members?.[userId].user?.isModerator as boolean,
    isAmbassador: channel?.state?.members?.[userId].user
      ?.isAmbassador as boolean,
    badge: channel?.state?.members?.[userId].user?.badge as Badge,
  }

  return (
    <IonItem
      className="py-3.5 channel-list-item cursor-pointer"
      onClick={() => history.push(`/messages/${userId}?page=${page}`)}
    >
      <span className="pr-4">
        <Avatar
          userId={userId}
          isModerator={data?.isModerator}
          isAmbassador={data?.isAmbassador}
          badge={data?.badge}
        />
      </span>
      <div className="min-w-[5.5rem]">
        <div className="text-base">
          <UserName className="block font-bold" name={data.username} />
        </div>
        <div className="block truncate text-ellipsis break-large text-base channel-list-message">
          {lastMessage?.text || latestMessage}
        </div>
      </div>
      <div
        className="min-w-[5.5rem] pt-5 text-right text-xs font-normal	channel-list-timestamp grow-0 items-end relative"
        slot="end"
      >
        {!!channel?.state?.unreadCount && (
          <div className="absolute top-1 right-0 w-2 h-2 bg-red-500 rounded-full" />
        )}
        {data?.lastMessageTimestamp}
      </div>
    </IonItem>
  )
}

export const ChannelListItem = memo(ChannelListItemComponent)
